import { render, staticRenderFns } from "./PanelBlock.vue?vue&type=template&id=c93e7d1c"
import script from "./PanelBlock.vue?vue&type=script&lang=js"
export * from "./PanelBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports